import getEnvironment from "../src/getEnvironment";
import getBuyerAPIDomain from "../src/APICalls/getBuyerAPIDomain";

const getLocationService = (
  locationName: string,
  isToUseAuthZero = false,
  authToken: string | undefined
) => {
  let url = getBuyerAPIDomain(isToUseAuthZero);
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  }

  if (getEnvironment() === "localhost") {
    if (!process.env.TOKEN) {
      console.log("TOKEN variable not set.");
    }

    headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
  }

  return fetch(`${url.href}/booking/collection/location/${locationName}`, {
    method: "GET",
    headers,
  });
};

export default getLocationService;
